interface CheckmarkCircleIconProps {
  color: string
  backgroundColor: string
  className?: string
}

const CheckmarkCircleIcon = ({
  color,
  backgroundColor,
  className,
}: CheckmarkCircleIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      transform="translate(0,0)"
      transform-origin="center"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={backgroundColor} />
      <path
        d="M18.3524 7.76459L9.61707 16.2352L5.64648 12.3849"
        stroke={color}
        stroke-width="1.5"
      />
    </svg>
  )
}

export default CheckmarkCircleIcon
